import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import './NotificationsPage.css';

import api from '../../Utils/Api';
import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext';
import { NotificationAddSharp } from '@mui/icons-material';
import ReactPaginate from 'react-paginate';
import Calendar from '../Calendar/Calendar';
import { Tooltip } from '@mui/material';

function formatDateTime(date) {
  const hours = (date.getHours() < 10 ? '0' : '') + date.getHours();
  const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  return (
    [
      date.getDate().toString().padStart(2, '0'),
      (date.getMonth() + 1).toString().padStart(2, '0'),
      date.getFullYear().toString().padStart(4, '0'),
    ].join('.') +
    ' ' +
    hours +
    ':' +
    minutes
  );
}

const NotificationsPage = ({}) => {
  const { setCurrentPlace } = useContext(JourneyContext);
  const { token } = useContext(CurrentUserContext);
  const [notifications, setNotifications] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [filter, setFilter] = useState(false);
  const [tab, setTab] = useState(false)
  const [titleTag, setTitle] = useState('_notify')
  
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  

  useEffect(() => {
    setCurrentPlace({ title: 'Уведомления' });
    Promise.all([api.getNotifications(token)])
      .then(([notifications]) => {
        setNotifications(notifications);
		    setFiltered(notifications)
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {}, [itemOffset]);
  function Items(currentItems) {
    return (
      <>
        {currentItems.currentItems && currentItems.currentItems.length > 0 ? (
          currentItems.currentItems.map((notification, index) => {
            if (notification.link_related_resource)
              return (             
                  <div
                    className={
                      notification.is_read
                        ? 'notficationsPage_notificationMessage readed'
                        : 'notficationsPage_notificationMessage'
                    }
                  >
                  <Tooltip
                    title={notification.is_read ? 'Прочитано' : 'Прочитать'}
                    placement="bottom-start"
                    followCursor
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#ffffff",
                          "box-shadow": "0px 4px 7px 0px #0000001C",
                          color: "#000000",
                          "font-size": "12px",
                          "line-height": "16px",
                          "border-radius": "10px",
                          fontFamily: "Montserrat",
                          fontWeight: 400,
                          padding: "6px 10px",
                          "& .MuiTooltip-arrow": {
                            color: "#8E93AF",
                          },
                        },
                      },
                    }}
                  >
                    <div
                      className={
                        notification.is_read
                          ? 'notficationsPage_readFlag_read'
                          : 'notficationsPage_readFlag_notRead'
                      }
                      onClick={() => handleRead(notification.id, index)}
                    />
                  </Tooltip>
                  
                  <Link
                    to={`${
                      'https' +
                      notification.link_related_resource.split('https')[1]
                    }`}
                    key={index}
                    onClick={() => handleRead(notification.id, index)}

                    >
                    <div className='notificationsPage_rightblock'>
                      {notification.theme}
                      <div className={ notification.is_read === true
                        ? 'notificationsPage_date readed_date'
                        : 'notificationsPage_date'}>
                      <div>
                        {formatDateTime(new Date(notification.created_at)).replace(/\s.*$/, '')}
                      </div>
                      <div>{formatDateTime(new Date(notification.created_at)).replace(/[^\s]*\s/,"")}</div>
                      </div>
                      <div className='notficationsPage_text'>
                        {notification.text}
                      </div>
                    </div>
                  </Link>
                  </div>
                
              );
            else
              return (
                <div
                  key={index}
                  className={
                    notification.is_read
                      ? 'notficationsPage_notificationMessage readed'
                      : 'notficationsPage_notificationMessage'
                  }
                >
                  <div
                    className={ notification.is_read
                      ? 'notficationsPage_readFlag_read' : 'notficationsPage_readFlag_notRead'}
                      onClick={() => handleRead(notification.id, index)}
                  />
                  <div className='notificationsPage_rightblock'>
                    {notification.theme}
                    {/* <div className='notificationsPage_date'> */}
                    <div className={ notification.is_read === true
                        ? 'notificationsPage_date readed_date'
                        : 'notificationsPage_date'}>
                      {formatDateTime(new Date(notification.created_at))}
                    </div>
                    <div className='notficationsPage_text'>
                      {notification.text}
                    </div>
                  </div>
                </div>
              );
          })
        ) : (
          <div className='headerMenu__notificationMessage_empty'>
            У вас нет новых уведомлений
          </div>
        )}
      </>
    );
  }

  function PaginatedItems({ itemsPerPage }) {
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.

    // Simulate fetching items from another resources.
    // (This could be items from props; or items loaded in a local state
    // from an API endpoint with useEffect and useState)
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = filtered.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filtered.length / itemsPerPage);

    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % filtered.length;
	    setCurrentPage(event.selected)
      setItemOffset(newOffset);
    };

    return (
      <>
        <Items currentItems={currentItems} />
        <ReactPaginate
          breakLabel='...'
          nextLabel='Следующая >'
          onPageChange={handlePageClick}
		      forcePage = {currentPage}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          offset={itemOffset}
          previousLabel='< Предыдущая'
          renderOnZeroPageCount={null}
        />
      </>
    );
  }

  const handleRead = async (readedId, index) => {
    return api.readNotification(token, readedId).then((res) => {
      let notifs = notifications.filter((noti) => {
        return noti.id !== readedId;
      });
      let notifydeleted = notifications.filter((noti) => {
        return noti.id === readedId;
      });
      notifydeleted[0].is_read = true;
      notifs.push(notifydeleted[0]);
      setNotifications(notifs);
      return readedId;
    });
  };

  const handleFilter = (filterType) => {
	let filtered = notifications
	if (notifications && filterType !== 'all') {
    filtered = notifications.filter((notification) => notification.is_read === filterType)
    setFiltered(filtered)
    setFilter(filterType)
    } else if (notifications && filterType === 'all') {
      setFiltered(notifications)
    }
  };

  const handleOpenTab = (title) => {
    if (title === 'Все уведомления') {
        setTab(false)
        setTitle('_notify')
    } else if (title === 'Календарь') {
        setTab(true)
        setTitle('_calendar') 
    } else if (title === 'Непрочитанные') {
      setTab(true)
      setTitle('_notRead') 
    }  else if (title === 'Прочитанные') {
      setTab(true)
      setTitle('_read') 
    }
  }
  
  const handleTabFilter = (title, bool) => {
    handleOpenTab(title)
    handleFilter(bool)
  }

  return (<>
    <div className='mainPage__container'>
    <div className='tab__wrap tab__notification__wrap'>
            <div className={'tab__btn' + (titleTag ? titleTag === '_notify' : '')} onClick={() => handleTabFilter('Все уведомления', 'all')}>Все уведомления</div>
            <div className={'tab__btn' + (titleTag ? titleTag === '_notRead' : '')} onClick={()=> handleTabFilter('Непрочитанные', false)}>Непрочитанные</div>
			      <div className={'tab__btn' + (titleTag ? titleTag === '_read' : '')} onClick={()=> handleTabFilter('Прочитанные', true)}>Прочитанные</div>
            {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : '')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
        </div>
    {tab && titleTag === '_calendar' && <div className='openedBlock__container'><Calendar></Calendar></div>}
    {(titleTag === '_notify' || titleTag === '_notRead' || titleTag === '_read') && 
    <div className='notificationsPage__container openedBlock__container'>
      <div className='notificationsPage__infoContainer'>
        {/* <div className='notificationsPage__navTree'>
          <Link to={'/'}>
            {' '}
            <div>Главная</div>{' '}
          </Link>
          <div className='current'>Уведомления</div>
        </div> */}
		{/* <div className='notificationsPage_filters'>
		<div className={!filter ?'notificationsPage_filter notificationsPage_filter_active' : 'notificationsPage_filter'} onClick={()=>{handleFilter(false)}}>Непрочитанные</div>
			
			<div>|</div>
			<div className={filter ?'notificationsPage_filter notificationsPage_filter_active' : 'notificationsPage_filter'} onClick={(ev)=>{handleFilter(true, ev)}}>Прочитанные</div>
	  </div> */}
      </div>

      <div className='notficationsPage_notifications'>
        {filtered && filtered.length > 0 ? (
          <PaginatedItems itemsPerPage={6} />
        ) : (
          <div className='headerMenu__notificationMessage_empty'>
            У вас нет новых уведомлений
          </div>
        )}
      </div>
    </div>}
    </div>
    </>
  );
};
export default NotificationsPage;
